import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Button, Nav } from "react-bootstrap";
import { FaBars, FaSearch, FaTimes } from 'react-icons/fa';
import AccountDropdown from './AccountDropdown';
import gaTracker from '../../util/ga-analytics/gaTracker';
import PegIcon from '../../images/svg/peg-icon.svg';
import PegIconRebrand from '../../images/rebrand/svg/peg-icon.svg'; //MediaQuery

import MediaQuery from 'react-responsive';
import { getSessionStorageKey } from '../../util/sessionStorage';
import { AuthenticationState } from 'react-aad-msal';
import { getLoyaltyStorage } from '../../util';
import { LoyaltyAccountStatus } from '../../util/LoyaltyAccountStatus';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Hamburger from '../../images/rebrand/svg/hamburger.svg';
export var SideMenu = function SideMenu(props) {
  var _pegCounterData$pegPo, _pegCounterData$pegPo2, _pegCounterData$pegPo3, _pegCounterData$pegPo4, _pegCounterData$pegPo5, _pegCounterData$pegIc, _pegCounterData$pegIc2;

  var searchActive = props.searchActive,
      mobile = props.mobile,
      handleLogin = props.handleLogin,
      handleShowModal = props.handleShowModal,
      handleShowSidebar = props.handleShowSidebar,
      closeSearch = props.closeSearch,
      displaySearch = props.displaySearch,
      accountInfo = props.accountInfo,
      authenticationState = props.authenticationState,
      isCnbSite = props.isCnbSite,
      isStorePortal = props.isStorePortal,
      _props$cartLength = props.cartLength,
      cartLength = _props$cartLength === void 0 ? 0 : _props$cartLength,
      pegCounterData = props.pegCounterData;

  var _useState = useState('0'),
      _useState2 = _slicedToArray(_useState, 2),
      pegPoints = _useState2[0],
      setPegPoints = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pausedAccount = _useState4[0],
      setPausedAccount = _useState4[1];

  var loyaltyStorage = getLoyaltyStorage();
  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  useEffect(function () {
    var _loyaltyStorage$accou;

    if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Balance) && authenticationState === 'Authenticated') {
      setPegPoints(loyaltyStorage.account.Balance);
    }

    if (authenticationState === AuthenticationState.Authenticated) {
      var _loyaltyStorage$accou2;

      if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.Status) === LoyaltyAccountStatus.Paused) {
        setPausedAccount(true);
      }
    }

    window.addEventListener("customEventSetLoyaltyAccountData", function (e) {
      var _e$detail, _e$detail$account;

      var Balance = (e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : (_e$detail$account = _e$detail.account) === null || _e$detail$account === void 0 ? void 0 : _e$detail$account.Balance) || null;

      if (Balance) {
        setPegPoints(Balance);
      }
    });
    return function () {
      window.removeEventListener("customEventSetLoyaltyAccountData", function () {});
    };
  }, []);
  useEffect(function () {
    var _props$loyaltyData, _props$loyaltyData$ac, _props$loyaltyData2, _props$loyaltyData2$a;

    if (((_props$loyaltyData = props.loyaltyData) === null || _props$loyaltyData === void 0 ? void 0 : (_props$loyaltyData$ac = _props$loyaltyData.account) === null || _props$loyaltyData$ac === void 0 ? void 0 : _props$loyaltyData$ac.Balance) && ((_props$loyaltyData2 = props.loyaltyData) === null || _props$loyaltyData2 === void 0 ? void 0 : (_props$loyaltyData2$a = _props$loyaltyData2.account) === null || _props$loyaltyData2$a === void 0 ? void 0 : _props$loyaltyData2$a.Balance) !== pegPoints && authenticationState === AuthenticationState.Authenticated) {
      var _props$loyaltyData3, _props$loyaltyData3$a;

      setPegPoints((_props$loyaltyData3 = props.loyaltyData) === null || _props$loyaltyData3 === void 0 ? void 0 : (_props$loyaltyData3$a = _props$loyaltyData3.account) === null || _props$loyaltyData3$a === void 0 ? void 0 : _props$loyaltyData3$a.Balance);
    }

    if (authenticationState !== AuthenticationState.Authenticated) {
      setPegPoints(0);
    }
  }, [props.loyaltyData]);

  var hamburgerMenuClick = function hamburgerMenuClick() {
    handleShowSidebar(true);
    var data = {
      gtm: {
        uniqueEventId: '21',
        elementId: "cb-header__hamburger"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var signInClick = function signInClick() {
    handleLogin();
    var data = {
      gtm: {
        uniqueEventId: '7',
        elementId: "cb-header__signin"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var cartClick = function cartClick() {
    var data = {
      gtm: {
        uniqueEventId: '20',
        elementId: mobile ? "banner-cart" : "banner-cart-mobile"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  if (isCnbSite) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
      as: "ul",
      className: "\n        cb-header__navbar-secondary cnb-nav-btn\n        ".concat(searchActive ? 'is-hidden' : '', "\n      ")
    }, /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      href: '/locations'
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, "Order Now"))))));
  }

  if (isStorePortal) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
      as: "ul",
      className: "\n          cb-header__navbar-secondary cnb-nav-btn\n            ".concat(searchActive ? 'is-hidden' : '', "\n          ")
    }, /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/shop/cart",
      id: mobile ? "banner-cart" : "banner-cart-mobile",
      onClick: cartClick,
      className: "position-relative"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-unstyled cb-button__shop"
    }, "Cart"), Boolean(cartLength) && /*#__PURE__*/React.createElement("span", {
      className: "cb-header__cart-indicator"
    }, cartLength))), /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: hamburgerMenuClick,
      id: "cb-header__hamburger",
      className: "cb-button-unstyled cb-header__button"
    }, useNewRebrandStyles ? /*#__PURE__*/React.createElement("img", {
      src: Hamburger,
      alt: "Hamburger"
    }) : /*#__PURE__*/React.createElement(FaBars, {
      className: "fa-3x"
    })))));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    as: "ul",
    className: "\n      cb-header__navbar-secondary\n      ".concat(searchActive ? 'is-hidden' : '', "\n    ")
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 901
  }, /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li",
    className: 'cb-header__peg-counter-li'
  }, /*#__PURE__*/React.createElement("a", {
    href: authenticationState !== AuthenticationState.Authenticated ? (pegCounterData === null || pegCounterData === void 0 ? void 0 : (_pegCounterData$pegPo = pegCounterData.pegPointLinkNotLoggedIn) === null || _pegCounterData$pegPo === void 0 ? void 0 : (_pegCounterData$pegPo2 = _pegCounterData$pegPo.value) === null || _pegCounterData$pegPo2 === void 0 ? void 0 : _pegCounterData$pegPo2.href) || '#' : (pegCounterData === null || pegCounterData === void 0 ? void 0 : (_pegCounterData$pegPo3 = pegCounterData.pegPointLinkLoggedIn) === null || _pegCounterData$pegPo3 === void 0 ? void 0 : (_pegCounterData$pegPo4 = _pegCounterData$pegPo3.value) === null || _pegCounterData$pegPo4 === void 0 ? void 0 : _pegCounterData$pegPo4.href) || '#',
    "aria-label": pausedAccount ? "".concat(pegPoints, " Pegs. Currently unavailable for redemption.") : '',
    className: "cb-header__peg-counter ".concat(pausedAccount ? 'cb-header__peg-counter--disabled' : '')
  }, /*#__PURE__*/React.createElement("span", {
    title: pegCounterData === null || pegCounterData === void 0 ? void 0 : (_pegCounterData$pegPo5 = pegCounterData.pegPointAlt) === null || _pegCounterData$pegPo5 === void 0 ? void 0 : _pegCounterData$pegPo5.value,
    className: 'cb-header__peg-counter__text'
  }, pegPoints), /*#__PURE__*/React.createElement("img", {
    className: 'cb-header__peg-counter__icon',
    src: useNewRebrandStyles ? PegIconRebrand : PegIcon,
    alt: pegCounterData === null || pegCounterData === void 0 ? void 0 : (_pegCounterData$pegIc = pegCounterData.pegIconAlt) === null || _pegCounterData$pegIc === void 0 ? void 0 : _pegCounterData$pegIc.value,
    title: pegCounterData === null || pegCounterData === void 0 ? void 0 : (_pegCounterData$pegIc2 = pegCounterData.pegIconAlt) === null || _pegCounterData$pegIc2 === void 0 ? void 0 : _pegCounterData$pegIc2.value
  })))), /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, mobile ? /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-unstyled cb-header__button cb-header__button--search",
    onClick: displaySearch
  }, /*#__PURE__*/React.createElement(FaSearch, null)) : authenticationState !== 'Authenticated' ? /*#__PURE__*/React.createElement(Button, {
    onClick: signInClick,
    className: "cb-button-unstyled",
    id: "cb-header__signin"
  }, "Sign In") : /*#__PURE__*/React.createElement(AccountDropdown, {
    authenticationState: authenticationState,
    accountInfo: accountInfo
  }))), /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: hamburgerMenuClick,
    id: "cb-header__hamburger",
    className: "cb-button-unstyled cb-header__button cb-header__button--hamburger"
  }, useNewRebrandStyles ? /*#__PURE__*/React.createElement("img", {
    src: Hamburger,
    alt: "Hamburger"
  }) : /*#__PURE__*/React.createElement(FaBars, {
    className: "fa-3x"
  })))), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(e) {
      return closeSearch();
    },
    className: "\n        cb-header__search-close\n        cb-header__button\n        cb-button-unstyled\n        ".concat(!searchActive ? 'is-hidden' : '', "\n        ")
  }, /*#__PURE__*/React.createElement(FaTimes, {
    className: "fa-3x"
  })));
};